import { LayerProps } from '@deck.gl/core';

const loadOptions: LayerProps['loadOptions'] = {
  mvt: {
    workerUrl:
      'https://cdn.jsdelivr.net/npm/@loaders.gl/mvt@4.3.4/dist/mvt-worker.js', // TODO: corrigir versão hardcoded
  },
};
export const defaultLayerProps = { loadOptions };
